import { useEffect, useState } from "react";
import { ISelectRangeProps } from "./SelectProductRangeInterfaces";
import { Form, Row, Col, Spinner } from "react-bootstrap";
import SearchDropDown from "../generic_components/SearchDropDown";
import "./css/SelectRange.css";
import "../../common/CommonStyle.css";
import { useProductRanges } from "../../api/simDocuments/ProductRangeService";

export default function SelectRange({
  onSelect,
  productRangeState,
}: ISelectRangeProps) {
  const { productRanges, loading: loadingProductRanges } = useProductRanges({
    productCompany: productRangeState.selectedCompany
      ? productRangeState.selectedCompany.key
      : "",
    archived: false,
  });

  const { productRanges: archivedProductRanges } = useProductRanges({
    productCompany: productRangeState.selectedCompany
      ? productRangeState.selectedCompany.key
      : "",
    archived: true,
  });

  const [combinedProductRange, setCombinedProductRange] =
    useState<{ key: string; label: string }[]>(productRanges);

  useEffect(() => {
    setCombinedProductRange(productRanges);
  }, [productRanges]);

  const handleSelect = (selectedKey: string) => {
    const productRange = selectedKey === "deselect" ? null : selectedKey;
    if (onSelect) {
      onSelect(productRange);
    }
  };

  const sortProductRanges = (ranges: { key: string; label: string }[]) => {
    return ranges.sort((a, b) => a.label.localeCompare(b.label));
  };

  return (
    <Row className="padding-top">
      <Col xs={2}>
        <label>Product Range</label>
      </Col>
      <Col xs={6} className="d-flex justify-content-start">
        {loadingProductRanges ? (
          <Spinner animation="border" />
        ) : (
          <SearchDropDown
            options={sortProductRanges(combinedProductRange)}
            onSelect={handleSelect}
          />
        )}

        <Form>
          <Form.Check
            type="checkbox"
            label="Also show archived"
            className="checkbox-margin"
            onChange={(e) => {
              const sortedRanges = e.target.checked
                ? sortProductRanges([
                    ...productRanges,
                    ...archivedProductRanges,
                  ])
                : sortProductRanges(productRanges);
              setCombinedProductRange(sortedRanges);
              if (onSelect) {
                onSelect(null);
              }
            }}
          />
        </Form>
      </Col>
    </Row>
  );
}
